import type { Card } from '../types'
import { CATEGORIAS, PRIORIDADES } from '../types'

interface Props {
  card: Card
  onClick: () => void
}

export default function KanbanCard({ card, onClick }: Props) {
  const cat = CATEGORIAS.find((c) => c.id === card.categoria)
  const prio = PRIORIDADES[card.prioridade]
  const isOverdue = card.data_limite && new Date(card.data_limite) < new Date() && card.coluna_id !== 'concluido'

  return (
    <div
      draggable
      onDragStart={(e) => {
        e.dataTransfer.setData('card-id', String(card.id))
        e.dataTransfer.effectAllowed = 'move'
      }}
      onClick={onClick}
      className={`bg-white rounded-lg shadow-sm border p-3 cursor-pointer hover:shadow-md transition-shadow ${
        isOverdue ? 'border-red-300' : 'border-gray-200'
      }`}
    >
      {/* Categoria + prioridade */}
      <div className="flex items-center justify-between mb-1.5">
        <span
          className="text-[10px] font-medium uppercase tracking-wide px-1.5 py-0.5 rounded"
          style={{ backgroundColor: cat?.cor + '20', color: cat?.cor }}
        >
          {cat?.nome ?? card.categoria}
        </span>
        <span
          className="w-2.5 h-2.5 rounded-full shrink-0"
          style={{ backgroundColor: prio.cor }}
          title={prio.nome}
        />
      </div>

      {/* Titulo */}
      <p className="text-sm font-medium text-gray-800 leading-snug">{card.titulo}</p>

      {/* Footer: tags + data */}
      <div className="flex items-center justify-between mt-2 gap-2">
        <div className="flex flex-wrap gap-1">
          {card.tags.slice(0, 3).map((t) => (
            <span key={t} className="text-[10px] bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded">
              {t}
            </span>
          ))}
        </div>
        {card.data_limite && (
          <span className={`text-[10px] shrink-0 ${isOverdue ? 'text-red-600 font-medium' : 'text-gray-400'}`}>
            {new Date(card.data_limite + 'T00:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' })}
          </span>
        )}
      </div>
    </div>
  )
}
